import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import R from 'ramda';
import Picture from '@cotyorg/ccx-atoms/Picture';
import { HeroFullBlock } from '@cotyorg/ccx-organism-hero';
import OptionalSection from '@cotyorg/ccx-utils/js/components/OptionalSection';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Link from '@cotyorg/ccx-atoms/Link';
import StandardLayout from '../../templates/StandardLayout';
import { isLargeBreakpoint } from '../../utils';

const mapIndexed = R.addIndex(R.map);

const HalloweenChooseYourCrown = ({
  currentBreakpoint,
  hero,
  images,
  bottomSection,
}) => (
  <div className="halloween-choose-your-crown-page">
    <StandardLayout>
      <Picture
        alt={R.path(['banner', 0, 'alt'], images)}
        src={R.path(['banner', 0, 'imageSrc'], images)}
        srcset={R.path(['banner', 0, 'imageSrcSet'], images)}
      />

      {mapIndexed(
        (heroKey, index) => (
          <div className={`hero-card_${index}`}>
            <HeroFullBlock
              key={heroKey}
              heroStoreDataKey={heroKey}
              isContentFirst={
                index % 2 !== 0 && isLargeBreakpoint({ currentBreakpoint })
              }
            />
          </div>
        ),
        R.keysIn(hero)
      )}
      <OptionalSection
        renderCondition={
          R.prop('heading', bottomSection) &&
          R.path(['call_to_action', 'url'], bottomSection)
        }
        section={() => (
          <div className="bottom-section">
            <Heading level={2}>{R.prop('heading', bottomSection)}</Heading>
            <Link
              extraClass="hero__cta-link hero-full-block__link"
              ctaType="button"
              link={R.path(['call_to_action', 'url'], bottomSection)}
              {...(R.path(
                ['call_to_action', 'open_in_new_window'],
                bottomSection
              ) && { target: '_blank' })}
            >
              {R.path(['call_to_action', 'title'], bottomSection)}
            </Link>
          </div>
        )}
      />
    </StandardLayout>
  </div>
);

HalloweenChooseYourCrown.propTypes = {
  images: PropTypes.arrayOf(PropTypes.object),
  hero: PropTypes.objectOf(PropTypes.object),
  bottomSection: PropTypes.objectOf(PropTypes.object),
  currentBreakpoint: PropTypes.string.isRequired,
};

export default connect(({ breakpoints, content }) => ({
  images: R.prop('images', content),
  hero: R.prop('hero', content),
  bottomSection: R.prop('bottomSection', content),
  currentBreakpoint: R.prop('current', breakpoints),
}))(HalloweenChooseYourCrown);
